var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} // eslint-disable-line max-lines


import ShowIf from "../../App/ShowIf";
import { ConnectionsGroups } from "../../ConnectionsList";
import { connectionsChanged, deleteConnection } from "../../ConnectionsList/actions/actions";
import { showTab } from "../../Entities/actions/uiActions";
import { t } from "../../I18N";

import SidePanel from "../../Layout/SidePanel";
import { MetadataForm } from "../../Metadata";
import { toggleOneUpLoadConnections } from "../actions/actions";
import { StateSelector } from "./StateSelector";
import Immutable from 'immutable';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TabContent, TabLink, Tabs } from 'react-tabs-redux';
import { bindActionCreators } from 'redux';



import { Icon } from "../../UI";
import { selectEntity, selectIsPristine, selectMlThesauri, selectOneUpState } from "../common";

const defaultProps = {
  entity: {},
  connectionsGroups: Immutable.fromJS([]),
  templates: Immutable.fromJS([]),
  mlThesauri: [],
  oneUpState: {},
  tab: 'info',
  panelOpen: true,
  selectedConnection: false,
  closePanel: () => {},
  showTab: (_tab) => ({}),
  connectionsChanged: () => {},
  deleteConnection: (_reference) => {},
  toggleOneUpLoadConnections: () => {}
};



export class OneUpSidePanelBase extends Component {


  mlProps() {var _templates$find, _template$get;
    const { entity, mlThesauri, templates } = this.props;
    const template = (_templates$find =
    templates.find((tmpl) => tmpl.get('_id') === entity.template)) !== null && _templates$find !== void 0 ? _templates$find : Immutable.fromJS({});
    const properties = (_template$get =
    template.get('properties')) !== null && _template$get !== void 0 ? _template$get : Immutable.fromJS([]);
    return properties.
    filter((p) => {var _get;return mlThesauri.includes((_get = p.get('content')) !== null && _get !== void 0 ? _get : '');}).
    map((p) => p.get('name')).
    toJS();
  }

  render() {var _entity$template$toSt, _entity$template;
    const { entity, tab, selectedConnection, connectionsGroups, oneUpState, panelOpen } =
    this.props;
    const selectedTab = tab !== null && tab !== void 0 ? tab : 'info';

    const summary = connectionsGroups.reduce(
    (summaryData, g) => {
      g.get('templates').forEach((tmpl) => {
        summaryData.totalConnections += tmpl.get('count'); // eslint-disable-line no-param-reassign
      });
      return summaryData;
    },
    { totalConnections: 0 });


    return /*#__PURE__*/(
      _jsx(SidePanel, {
        className: `entity-connections entity-${this.props.tab}`,
        open: panelOpen && !selectedConnection }, void 0, /*#__PURE__*/

      _jsx("div", { className: "sidepanel-header content-header-tabs" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "blank" }), /*#__PURE__*/
      _jsx(Tabs, {
        selectedTab: selectedTab,
        handleSelect: (tabName) => {
          this.props.showTab(tabName);
        } }, void 0, /*#__PURE__*/

      _jsx("ul", { className: "nav nav-tabs" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(TabLink, { to: "info", component: "div" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Info')))), /*#__PURE__*/


      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(TabLink, { to: "connections", component: "div" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
      _jsx("span", { className: "connectionsNumber" }, void 0, summary.totalConnections), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Relationships')))))), /*#__PURE__*/




      _jsx("button", {
        type: "button",
        className: "closeSidepanel close-modal",
        onClick: this.props.closePanel }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" }))), /*#__PURE__*/


      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx(Tabs, { selectedTab: selectedTab }, void 0, /*#__PURE__*/
      _jsx(TabContent, { for: selectedTab === 'connections' ? selectedTab : 'none' }, void 0, /*#__PURE__*/
      _jsx(ConnectionsGroups, { connectionsGroups: connectionsGroups })), /*#__PURE__*/

      _jsx(TabContent, { for: selectedTab === 'info' ? selectedTab : 'none' }, void 0, /*#__PURE__*/
      _jsx(MetadataForm, {
        id: "sidePanelMetadataForm",
        model: "entityView.entityForm",
        templateId: (_entity$template$toSt = (_entity$template = entity.template) === null || _entity$template === void 0 ? void 0 : _entity$template.toString()) !== null && _entity$template$toSt !== void 0 ? _entity$template$toSt : '',
        showSubset: this.mlProps(),
        version: "OneUp" })))), /*#__PURE__*/




      _jsx(ShowIf, { if: selectedTab === 'connections' }, void 0, /*#__PURE__*/
      _jsx(StateSelector, { isPristine: selectIsPristine }, void 0,
      ({ isPristine }) => /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => this.props.toggleOneUpLoadConnections(),
        className: isPristine ? 'btn btn-default' : 'btn btn-default btn-disabled' }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: oneUpState.loadConnections ? 'times' : 'undo' }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0,
      t(
      'System',
      oneUpState.loadConnections ? 'Hide Connections' : 'Load Connections'))))))));









  }
}_defineProperty(OneUpSidePanelBase, "defaultProps", defaultProps);

const mapStateToProps = (state) => {var _selectOneUpState;return {
    entity: selectEntity(state),
    connectionsGroups: state.relationships.list.connectionsGroups,
    selectedConnection: Boolean(
    state.relationships.connection && state.relationships.connection.get('_id')),

    tab: state.entityView.uiState.get('tab'),
    oneUpState: (_selectOneUpState = selectOneUpState(state)) !== null && _selectOneUpState !== void 0 ? _selectOneUpState : {},
    templates: state.templates,
    mlThesauri: selectMlThesauri(state)
  };};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    connectionsChanged,
    deleteConnection,
    showTab,
    toggleOneUpLoadConnections
  },
  dispatch);

}

export const OneUpSidePanel = connect(mapStateToProps, mapDispatchToProps)(OneUpSidePanelBase);